import { useQuery } from '@apollo/client';
import { EXTENDED_GRAPHQL_TIMEOUT_MS } from '@core/services/constants';

import { AUDIT_SESSION_FILTER_OPTIONS_QUERY } from '../graphql/queries/auditSessionFilterOptions';

export interface StandardLabel {
  id: string;
  labelName: string;
  labelShortName: string;
  labelNumMap: number;
  contentType: string;
}

export interface AuditSessionFilterOptions {
  standardLabels: StandardLabel[];
  topics: string[];
  languages: string[];
  severityLevels: number[];
  contentTypes: string[];
}

interface AuditSessionFilterOptionsData {
  auditSessionFilterOptions: AuditSessionFilterOptions;
}

interface AuditSessionFilterOptionsVariables {
  communityId: string;
}

/**
 * Hook to fetch filter options for audit session creation
 * @param communityId The ID of the community to get filter options for
 * @returns Query result with filter options data, loading state, and error
 */
export function useAuditSessionFilterOptions(communityId: string) {
  const { data, loading, error, refetch } = useQuery<AuditSessionFilterOptionsData, AuditSessionFilterOptionsVariables>(AUDIT_SESSION_FILTER_OPTIONS_QUERY, {
    variables: { communityId },
    skip: !communityId,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    context: { timeout: EXTENDED_GRAPHQL_TIMEOUT_MS },
  });

  return {
    filterOptions: data?.auditSessionFilterOptions,
    loading,
    error,
    refetch,
  };
}
